<template>
  <v-card v-if="!isMobile" height="100%">
    <v-navigation-drawer>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>All Categories</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item-group v-model="currentCategory" color="primary">
          <v-list-item v-for="(category, i) in categories" :key="i" :to="{ name: 'CategoryPage', params: { categoryId: category.id } }">
            <v-list-item-icon v-if="category.icon">
              <v-icon v-text="category.icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="category.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
  export default {
    name: "CategoryMenu",

    data() {
      return {
        currentCategory: 0,
      };
    },

    props: {
      categories: {
        type: Array,
      },
    },

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Catalog/CategoryMenu.vue